export class User {
    'id';
    'givenName';
    'email';
    'expiresAt';
    'roleToProjectsMappings';
    'userOrigin';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "givenName",
            "baseName": "givenName",
            "type": "string",
            "format": ""
        },
        {
            "name": "email",
            "baseName": "email",
            "type": "string",
            "format": ""
        },
        {
            "name": "expiresAt",
            "baseName": "expiresAt",
            "type": "string",
            "format": ""
        },
        {
            "name": "roleToProjectsMappings",
            "baseName": "roleToProjectsMappings",
            "type": "{ [key: string]: IDs; }",
            "format": ""
        },
        {
            "name": "userOrigin",
            "baseName": "userOrigin",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return User.attributeTypeMap;
    }
    constructor() {
    }
}
